import React, { useState } from 'react';
import { Box, Inscription, WarningIcon } from '@common-fe/common-fe';

import Tip from '@/components/elements/Tip/Tip';

import { ContactResponseModel } from '../ContactSecurity.types';

import { RemovingAccountManagerAssignmentPopup } from './RemovingAccountManagerAssignmentPopup';

interface Props {
  contact?: Partial<ContactResponseModel>;
  names?: string[];
  onSuccess?: () => void;
}

export const RemovingAccountManagerAssignment: React.FC<Props> = ({ contact, names, onSuccess }) => {
  const [hasPopup, setHasPopup] = useState(false);

  return (
    <Box data-testId="RemovingAccountManagerAssignment" direction="row" align="center">
      <Inscription color="textBody" margin={{ right: 'spacing12' }}>
        Account Manager
      </Inscription>
      <Tip
        hint={(
          <Box width="208px"pad={{ left: 'spacing8' }} style={{ cursor: 'auto'}}>
            <Inscription color="textOnColor" size="small" style={{ whiteSpace: 'normal' }} weight={500}>
              This user is currently assigned as an Account Manager (AM). To change their job function, first remove their assignment.
            </Inscription>
            <Inscription
              color="danger"
              size="small"
              margin={{ top: 'spacing8' }}
              weight={500}
              onClick={() => setHasPopup(true)}
              cursor="pointer"
            >
              Remove AM Assignment
            </Inscription>
          </Box>
        )}
        space="38px"
      >
        <Box pad={{ right: 'spacing8' }}><WarningIcon /></Box>
      </Tip>

      {hasPopup ? (
        <RemovingAccountManagerAssignmentPopup
          close={() => setHasPopup(false)}
          contact={contact}
          names={names}
          onSuccess={onSuccess}
        />
      ) : null}
    </Box>
  );
};
